/**
 * Creates an {@link Emitter}.
 * @param eventEmitter - An event emitter.
 * @param eventName - Event name.
 * @internal
 */
export function _makeEmitter(eventEmitter) {
  var eventName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "event";
  return {
    addListener: function addListener(listener) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (options.once) {
        eventEmitter.once(eventName, listener);
      } else {
        eventEmitter.addListener(eventName, listener);
      }
    },
    removeListener: function removeListener(listener) {
      eventEmitter.removeListener(eventName, listener);
    },
    on: function on(listener) {
      eventEmitter.on(eventName, listener);
    },
    off: function off(listener) {
      eventEmitter.removeListener(eventName, listener);
    },
    once: function once(listener) {
      eventEmitter.once(eventName, listener);
    }
  };
}